The organization or person requesting to post a position.
